module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img20.16e1d60b.jpg";